<template>
    <v-dialog v-model="show" max-width="280">
        <v-btn large color="white" block tile @click="close">
            <span class="primary--text">닫기</span>
        </v-btn>
    </v-dialog>
</template>

<script>

export default {
    data() {
        return {
            show: false,
        }
    },
    methods:{
        open(){
            this.show = true
        },
        close(){
            this.show = false
        }
    }
}
</script>

<style>

</style>